import { graphql, useMutation } from "react-relay";
import { useWorkspaceTodoEditAddFileMutation } from "./__generated__/useWorkspaceTodoEditAddFileMutation.graphql";

export function useWorkspaceTodoEditAddFiles() {
  const [addFileMutation] = useMutation<useWorkspaceTodoEditAddFileMutation>(
    graphql`
      mutation useWorkspaceTodoEditAddFileMutation(
        $todoWorkspaceId: ID!
        $fileIds: [ID!]!
      ) {
        todoWorkspace(id: $todoWorkspaceId) {
          addFiles(fileIds: $fileIds) {
            id
            ...WorkspaceTodoEditMainEditedInfo_Todo
            descriptionFiles {
              id
              type
              url
              name
            }
          }
        }
      }
    `
  );

  return (todoWorkspaceId: string, fileIds: string[]) => {
    return addFileMutation({
      variables: {
        todoWorkspaceId,
        fileIds,
      },
    });
  };
}
